import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ExternalLink } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';

/**
 * QuoteCalculator slim utility band.
 *
 * iter114s.35 — The full brand band (logo + "Evergreen Graphics Group
 * Inc" + subline) was retired here for the same reason it was retired
 * on /splash: the global TopNav already carries the logo + brand name
 * + nav links, so a second stacked band on this page just duplicated
 * chrome. The wizard-specific utility controls (View Products,
 * Currency selector, Phone CTA) survive in a narrow utility strip
 * with a subtle border underneath the TopNav.
 */
export const QuoteHeader = ({ currency, onCurrencyChange }) => (
  <div
    className="bg-white border-b border-[#E5E7EB]"
    data-testid="quote-utility-band"
  >
    <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-6 flex-wrap">
      <Link
        to="/products"
        className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#4A7C59] hover:text-[#2F5D3A] transition-colors"
        data-testid="quote-view-products-link"
      >
        <ExternalLink className="w-4 h-4" />
        View Products
      </Link>

      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <span className="text-xs uppercase tracking-[0.15em] text-[#4A7C59] font-semibold">Currency</span>
          <Select value={currency} onValueChange={onCurrencyChange}>
            <SelectTrigger className="w-24 bg-white border-[#E5E7EB] text-[#14281D] font-semibold" data-testid="quote-currency-trigger">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="USD">USD $</SelectItem>
              <SelectItem value="CAD">CAD $</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <a
          href="tel:9054470257"
          className="hidden md:flex items-center gap-2 text-sm font-semibold text-[#14281D] hover:text-[#6FBF73] transition-colors"
          data-testid="quote-phone-cta"
        >
          <Phone className="w-4 h-4 text-[#6FBF73]" />
          <span>(905) 447-0257</span>
        </a>
      </div>
    </div>
  </div>
);

export default QuoteHeader;
